import Devices from "../models/devices.ts";

const DeviceLayoutDummyData = [
    {
        device: new Devices({
            id: "84960297-c1fa-16b3-a339-60ab148ff8e9",
            type: "washer",
            name: "Washer 1",
            status: "error",
            courseName: undefined,
            remainTime: undefined,
            model: "FH069FD_T",
            dryType: "nonHeater",
            cycle: 1000,
        }),
        location: { column: 4, row: 2, bottom: false },
    },
    {
        device: new Devices({
            id: "84960297-c1fa-16b3-a339-60ab148ff8e0",
            type: "dryer",
            name: "Dryer 1",
            status: "standby",
            courseName: undefined,
            remainTime: undefined,
            model: "FH069FD_T",
            dryType: "dryer",
            cycle: 1000,
        }),
        location: { column: 4, row: 2, bottom: true },
    },
    {
        device: new Devices({
            id: "84960297-c1fa-16b3-a339-60ab148ff8e8",
            type: "washer",
            name: "Washer 2",
            status: "error",
            courseName: undefined,
            remainTime: undefined,
            model: "FH069FD_T",
            dryType: "nonHeater",
            cycle: 1000,
        }),
        location: { column: 5, row: 2, bottom: true },
    },
    {
        device: new Devices({
            type: "dryer",
            name: "Dryer 2",
            status: "inUse",
            courseName: "Warm",
            remainTime: "00:15",
            model: "FH069FD_T",
            id: "84960297-c1fa-16b3-a339-60ab148ff8e3",
            dryType: "dryer",
            cycle: 1000,
        }),
        location: { column: 5, row: 2, bottom: false },
    },
];

export default DeviceLayoutDummyData;
